module.exports = __webpack_public_path__ + "img/307fe5a.webp";